/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: xjflvWz4bB4Q

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFooterTopNav.module.css"; // plasmic-import: xjflvWz4bB4Q/css

createPlasmicElementProxy;

export type PlasmicFooterTopNav__VariantMembers = {};
export type PlasmicFooterTopNav__VariantsArgs = {};
type VariantPropType = keyof PlasmicFooterTopNav__VariantsArgs;
export const PlasmicFooterTopNav__VariantProps = new Array<VariantPropType>();

export type PlasmicFooterTopNav__ArgsType = { onContactClick?: () => void };
type ArgPropType = keyof PlasmicFooterTopNav__ArgsType;
export const PlasmicFooterTopNav__ArgProps = new Array<ArgPropType>(
  "onContactClick"
);

export type PlasmicFooterTopNav__OverridesType = {
  navs?: Flex__<"div">;
  desktop?: Flex__<"div">;
  generalStayInTouch?: Flex__<"div">;
  general?: Flex__<"div">;
  head?: Flex__<"h6">;
  items?: Flex__<"nav">;
  link?: Flex__<"div">;
  link2?: Flex__<"div">;
  link3?: Flex__<"div">;
  link5?: Flex__<"div">;
  link6?: Flex__<"div">;
  stayInTouch?: Flex__<"div">;
  head2?: Flex__<"h6">;
  links?: Flex__<"div">;
  x?: Flex__<"a"> & Partial<LinkProps>;
  fb?: Flex__<"a"> & Partial<LinkProps>;
  ig?: Flex__<"a"> & Partial<LinkProps>;
  li?: Flex__<"a"> & Partial<LinkProps>;
  th?: Flex__<"a"> & Partial<LinkProps>;
  resources2?: Flex__<"div">;
  resources?: Flex__<"div">;
  head5?: Flex__<"h6">;
  items4?: Flex__<"nav">;
  link36?: Flex__<"div">;
  link38?: Flex__<"div">;
  link37?: Flex__<"div">;
  mobile?: Flex__<"div">;
  generaSolutions?: Flex__<"div">;
  general3?: Flex__<"div">;
  head11?: Flex__<"h6">;
  items9?: Flex__<"nav">;
  link81?: Flex__<"div">;
  link82?: Flex__<"div">;
  link83?: Flex__<"div">;
  link85?: Flex__<"div">;
  link86?: Flex__<"div">;
  stayInTouch3?: Flex__<"div">;
  head12?: Flex__<"h6">;
  links3?: Flex__<"div">;
  x3?: Flex__<"a"> & Partial<LinkProps>;
  fb3?: Flex__<"a"> & Partial<LinkProps>;
  ig3?: Flex__<"a"> & Partial<LinkProps>;
  li3?: Flex__<"a"> & Partial<LinkProps>;
  th3?: Flex__<"a"> & Partial<LinkProps>;
  productsResources?: Flex__<"div">;
  resources5?: Flex__<"div">;
  resources6?: Flex__<"div">;
  head15?: Flex__<"h6">;
  items12?: Flex__<"nav">;
  link116?: Flex__<"div">;
  link118?: Flex__<"div">;
  link117?: Flex__<"div">;
};

export interface DefaultFooterTopNavProps {
  onContactClick?: () => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFooterTopNav__RenderFunc(props: {
  variants: PlasmicFooterTopNav__VariantsArgs;
  args: PlasmicFooterTopNav__ArgsType;
  overrides: PlasmicFooterTopNav__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"navs"}
      data-plasmic-override={overrides.navs}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.navs
      )}
    >
      <div
        data-plasmic-name={"desktop"}
        data-plasmic-override={overrides.desktop}
        className={classNames(projectcss.all, sty.desktop)}
      >
        <div
          data-plasmic-name={"generalStayInTouch"}
          data-plasmic-override={overrides.generalStayInTouch}
          className={classNames(projectcss.all, sty.generalStayInTouch)}
        >
          <div
            data-plasmic-name={"general"}
            data-plasmic-override={overrides.general}
            className={classNames(projectcss.all, sty.general)}
          >
            <h6
              data-plasmic-name={"head"}
              data-plasmic-override={overrides.head}
              className={classNames(
                projectcss.all,
                projectcss.h6,
                projectcss.__wab_text,
                sty.head
              )}
            >
              {"General"}
            </h6>
            <nav
              data-plasmic-name={"items"}
              data-plasmic-override={overrides.items}
              className={classNames(projectcss.all, sty.items)}
            >
              <div
                data-plasmic-name={"link"}
                data-plasmic-override={overrides.link}
                aria-label={"Home"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link
                )}
                title={"Home"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__ea7W
                      )}
                      component={Link}
                      href={`/`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"Home"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link2"}
                data-plasmic-override={overrides.link2}
                aria-label={"Features"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link2
                )}
                title={"Features"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__uh2YX
                      )}
                      component={Link}
                      href={`/features`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"Features"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link3"}
                data-plasmic-override={overrides.link3}
                aria-label={"Pricing"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link3
                )}
                title={"Pricing"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link___1Yu16
                      )}
                      component={Link}
                      href={`/pricing`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"Pricing"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link5"}
                data-plasmic-override={overrides.link5}
                aria-label={"Open contact modal"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link5
                )}
                title={"Open contact modal"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__bmFdC
                      )}
                      component={Link}
                      legacyBehavior={false}
                      onClick={async event => {
                        const $steps = {};

                        $steps["runOnContactClick"] = true
                          ? (() => {
                              const actionArgs = {
                                eventRef: $props["onContactClick"]
                              };
                              return (({ eventRef, args }) => {
                                return eventRef?.(...(args ?? []));
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["runOnContactClick"] != null &&
                          typeof $steps["runOnContactClick"] === "object" &&
                          typeof $steps["runOnContactClick"].then === "function"
                        ) {
                          $steps["runOnContactClick"] =
                            await $steps["runOnContactClick"];
                        }
                      }}
                      platform={"nextjs"}
                    >
                      {"Contact"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link6"}
                data-plasmic-override={overrides.link6}
                aria-label={"Request demo"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link6
                )}
                title={"Request demo"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__crPtM
                      )}
                      component={Link}
                      href={
                        "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
                      }
                      legacyBehavior={false}
                      platform={"nextjs"}
                      target={"_blank"}
                    >
                      {"Request Demo"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
            </nav>
          </div>
          <div
            data-plasmic-name={"stayInTouch"}
            data-plasmic-override={overrides.stayInTouch}
            className={classNames(projectcss.all, sty.stayInTouch)}
          >
            <h6
              data-plasmic-name={"head2"}
              data-plasmic-override={overrides.head2}
              className={classNames(
                projectcss.all,
                projectcss.h6,
                projectcss.__wab_text,
                sty.head2
              )}
            >
              {"Stay in Touch"}
            </h6>
            <div
              data-plasmic-name={"links"}
              data-plasmic-override={overrides.links}
              className={classNames(projectcss.all, sty.links)}
            >
              <PlasmicLink__
                data-plasmic-name={"x"}
                data-plasmic-override={overrides.x}
                aria-label={"Open MyEvaluations X page"}
                className={classNames(projectcss.all, projectcss.a, sty.x)}
                component={Link}
                href={"https://twitter.com/myevaluations/media"}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
                title={"Open MyEvaluations X page"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__aP9Nl)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/5c16cc6098d8223f6ee21c936cbdbc43.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
              <PlasmicLink__
                data-plasmic-name={"fb"}
                data-plasmic-override={overrides.fb}
                aria-label={"Open MyEvaluations Facebook page"}
                className={classNames(projectcss.all, projectcss.a, sty.fb)}
                component={Link}
                href={"https://web.facebook.com/myevaluations"}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
                title={"Open MyEvaluations Facebook page"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__xWwyn)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/24dbb12092ac2a0b739d01ca30614897.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
              <PlasmicLink__
                data-plasmic-name={"ig"}
                data-plasmic-override={overrides.ig}
                aria-label={"Open MyEvaluations Instagram page"}
                className={classNames(projectcss.all, projectcss.a, sty.ig)}
                component={Link}
                href={"https://www.instagram.com/myevaluations/"}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
                title={"Open MyEvaluations Instagram page"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__pg7AW)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/bdd639079ea2546ece1ab194ad192475.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
              <PlasmicLink__
                data-plasmic-name={"li"}
                data-plasmic-override={overrides.li}
                aria-label={"Open MyEvaluations LinkedIn page"}
                className={classNames(projectcss.all, projectcss.a, sty.li)}
                component={Link}
                href={
                  "https://www.linkedin.com/company/myevaluations.com-inc/?viewAsMember=true"
                }
                legacyBehavior={false}
                platform={"nextjs"}
                title={"Open MyEvaluations LinkedIn page"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__oDhLi)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/1542355768a34cbafbf427680e35942f.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
              <PlasmicLink__
                data-plasmic-name={"th"}
                data-plasmic-override={overrides.th}
                aria-label={"Open MyEvaluations Threads page"}
                className={classNames(projectcss.all, projectcss.a, sty.th)}
                component={Link}
                href={"https://www.threads.net/@myevaluations"}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
                title={"Open MyEvaluations Threads page"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__bVu6)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  onClick={async event => {
                    const $steps = {};

                    $steps["goToPage"] = true
                      ? (() => {
                          const actionArgs = { destination: "" };
                          return (({ destination }) => {
                            if (
                              typeof destination === "string" &&
                              destination.startsWith("#")
                            ) {
                              document
                                .getElementById(destination.substr(1))
                                .scrollIntoView({ behavior: "smooth" });
                            } else {
                              __nextRouter?.push(destination);
                            }
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["goToPage"] != null &&
                      typeof $steps["goToPage"] === "object" &&
                      typeof $steps["goToPage"].then === "function"
                    ) {
                      $steps["goToPage"] = await $steps["goToPage"];
                    }
                  }}
                  src={{
                    src: "https://site-assets.plasmic.app/0c6bcef4caa3daf40c5ce4a872fcc13b.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"resources2"}
          data-plasmic-override={overrides.resources2}
          className={classNames(projectcss.all, sty.resources2)}
        >
          <div
            data-plasmic-name={"resources"}
            data-plasmic-override={overrides.resources}
            className={classNames(projectcss.all, sty.resources)}
          >
            <h6
              data-plasmic-name={"head5"}
              data-plasmic-override={overrides.head5}
              className={classNames(
                projectcss.all,
                projectcss.h6,
                projectcss.__wab_text,
                sty.head5
              )}
            >
              {"Resources"}
            </h6>
            <nav
              data-plasmic-name={"items4"}
              data-plasmic-override={overrides.items4}
              className={classNames(projectcss.all, sty.items4)}
            >
              <div
                data-plasmic-name={"link36"}
                data-plasmic-override={overrides.link36}
                aria-label={"Compliance & Certifications"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link36,
                  ``
                )}
                title={"Compliance & Certifications"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__mTGul
                      )}
                      component={Link}
                      href={`/m/compliance-and-certifications`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      <React.Fragment>
                        {"Compliance & Certifications"}
                      </React.Fragment>
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link38"}
                data-plasmic-override={overrides.link38}
                aria-label={"Privacy Policy"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link38,
                  ``
                )}
                title={"Privacy Policy"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__pSt52
                      )}
                      component={Link}
                      href={`/m/privacy-policy`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"Privacy Policy"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link37"}
                data-plasmic-override={overrides.link37}
                aria-label={"Accessibility Statement"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link37
                )}
                title={"Accessibility Statement"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__rEzin
                      )}
                      component={Link}
                      href={`/m/accessibility-statement`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"Accessibility Statement"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div
        data-plasmic-name={"mobile"}
        data-plasmic-override={overrides.mobile}
        className={classNames(projectcss.all, sty.mobile)}
      >
        <div
          data-plasmic-name={"generaSolutions"}
          data-plasmic-override={overrides.generaSolutions}
          className={classNames(projectcss.all, sty.generaSolutions)}
        >
          <div
            data-plasmic-name={"general3"}
            data-plasmic-override={overrides.general3}
            className={classNames(projectcss.all, sty.general3)}
          >
            <h6
              data-plasmic-name={"head11"}
              data-plasmic-override={overrides.head11}
              className={classNames(
                projectcss.all,
                projectcss.h6,
                projectcss.__wab_text,
                sty.head11
              )}
            >
              {"General"}
            </h6>
            <nav
              data-plasmic-name={"items9"}
              data-plasmic-override={overrides.items9}
              className={classNames(projectcss.all, sty.items9)}
            >
              <div
                data-plasmic-name={"link81"}
                data-plasmic-override={overrides.link81}
                aria-label={"Home"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link81
                )}
                title={"Home"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__gCjg
                      )}
                      component={Link}
                      href={`/`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"Home"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link82"}
                data-plasmic-override={overrides.link82}
                aria-label={"Features"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link82
                )}
                title={"Features"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__yzzJf
                      )}
                      component={Link}
                      href={`/features`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"Features"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link83"}
                data-plasmic-override={overrides.link83}
                aria-label={"Pricing"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link83
                )}
                title={"Pricing"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__n8NP
                      )}
                      component={Link}
                      href={`/pricing`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"Pricing"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link85"}
                data-plasmic-override={overrides.link85}
                aria-label={"Open contact modal"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link85
                )}
                title={"Open contact modal"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__dv2C
                      )}
                      component={Link}
                      legacyBehavior={false}
                      onClick={async event => {
                        const $steps = {};

                        $steps["runOnContactClick"] = true
                          ? (() => {
                              const actionArgs = {
                                eventRef: $props["onContactClick"]
                              };
                              return (({ eventRef, args }) => {
                                return eventRef?.(...(args ?? []));
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["runOnContactClick"] != null &&
                          typeof $steps["runOnContactClick"] === "object" &&
                          typeof $steps["runOnContactClick"].then === "function"
                        ) {
                          $steps["runOnContactClick"] =
                            await $steps["runOnContactClick"];
                        }
                      }}
                      platform={"nextjs"}
                    >
                      {"Contact"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                data-plasmic-name={"link86"}
                data-plasmic-override={overrides.link86}
                aria-label={"Request demo"}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.link86
                )}
                onClick={async event => {
                  const $steps = {};

                  $steps["goToRequestDemo"] = true
                    ? (() => {
                        const actionArgs = {};
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            __nextRouter?.push(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToRequestDemo"] != null &&
                    typeof $steps["goToRequestDemo"] === "object" &&
                    typeof $steps["goToRequestDemo"].then === "function"
                  ) {
                    $steps["goToRequestDemo"] = await $steps["goToRequestDemo"];
                  }
                }}
                title={"Request demo"}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__qg4C
                      )}
                      component={Link}
                      href={
                        "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
                      }
                      legacyBehavior={false}
                      platform={"nextjs"}
                      target={"_blank"}
                    >
                      {"Request Demo"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
            </nav>
          </div>
          <div
            data-plasmic-name={"stayInTouch3"}
            data-plasmic-override={overrides.stayInTouch3}
            className={classNames(projectcss.all, sty.stayInTouch3)}
          >
            <h6
              data-plasmic-name={"head12"}
              data-plasmic-override={overrides.head12}
              className={classNames(
                projectcss.all,
                projectcss.h6,
                projectcss.__wab_text,
                sty.head12
              )}
            >
              {"Stay in Touch"}
            </h6>
            <div
              data-plasmic-name={"links3"}
              data-plasmic-override={overrides.links3}
              className={classNames(projectcss.all, sty.links3)}
            >
              <PlasmicLink__
                data-plasmic-name={"x3"}
                data-plasmic-override={overrides.x3}
                className={classNames(projectcss.all, projectcss.a, sty.x3)}
                component={Link}
                href={"https://twitter.com/myevaluations/media"}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__gzznv)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/5c16cc6098d8223f6ee21c936cbdbc43.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
              <PlasmicLink__
                data-plasmic-name={"fb3"}
                data-plasmic-override={overrides.fb3}
                className={classNames(projectcss.all, projectcss.a, sty.fb3)}
                component={Link}
                href={"https://www.facebook.com/myevaluations"}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__gfYvj)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/24dbb12092ac2a0b739d01ca30614897.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
              <PlasmicLink__
                data-plasmic-name={"ig3"}
                data-plasmic-override={overrides.ig3}
                className={classNames(projectcss.all, projectcss.a, sty.ig3)}
                component={Link}
                href={"https://www.instagram.com/myevaluations/"}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__x9IAn)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/bdd639079ea2546ece1ab194ad192475.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
              <PlasmicLink__
                data-plasmic-name={"li3"}
                data-plasmic-override={overrides.li3}
                className={classNames(projectcss.all, projectcss.a, sty.li3)}
                component={Link}
                href={
                  "https://www.linkedin.com/company/myevaluations.com-inc/?viewAsMember=true"
                }
                legacyBehavior={false}
                platform={"nextjs"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__z6NSd)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/1542355768a34cbafbf427680e35942f.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
              <PlasmicLink__
                data-plasmic-name={"th3"}
                data-plasmic-override={overrides.th3}
                className={classNames(projectcss.all, projectcss.a, sty.th3)}
                component={Link}
                href={"https://www.threads.net/@myevaluations"}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__m5FG0)}
                  displayHeight={"24px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"24px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  onClick={async event => {
                    const $steps = {};

                    $steps["goToPage"] = true
                      ? (() => {
                          const actionArgs = { destination: "" };
                          return (({ destination }) => {
                            if (
                              typeof destination === "string" &&
                              destination.startsWith("#")
                            ) {
                              document
                                .getElementById(destination.substr(1))
                                .scrollIntoView({ behavior: "smooth" });
                            } else {
                              __nextRouter?.push(destination);
                            }
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["goToPage"] != null &&
                      typeof $steps["goToPage"] === "object" &&
                      typeof $steps["goToPage"].then === "function"
                    ) {
                      $steps["goToPage"] = await $steps["goToPage"];
                    }
                  }}
                  src={{
                    src: "https://site-assets.plasmic.app/0c6bcef4caa3daf40c5ce4a872fcc13b.svg",
                    fullWidth: 24,
                    fullHeight: 24,
                    aspectRatio: 1
                  }}
                />
              </PlasmicLink__>
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"productsResources"}
          data-plasmic-override={overrides.productsResources}
          className={classNames(projectcss.all, sty.productsResources)}
        >
          <div
            data-plasmic-name={"resources5"}
            data-plasmic-override={overrides.resources5}
            className={classNames(projectcss.all, sty.resources5)}
          >
            <div
              data-plasmic-name={"resources6"}
              data-plasmic-override={overrides.resources6}
              className={classNames(projectcss.all, sty.resources6)}
            >
              <h6
                data-plasmic-name={"head15"}
                data-plasmic-override={overrides.head15}
                className={classNames(
                  projectcss.all,
                  projectcss.h6,
                  projectcss.__wab_text,
                  sty.head15
                )}
              >
                {"Resources"}
              </h6>
              <nav
                data-plasmic-name={"items12"}
                data-plasmic-override={overrides.items12}
                className={classNames(projectcss.all, sty.items12)}
              >
                <div
                  data-plasmic-name={"link116"}
                  data-plasmic-override={overrides.link116}
                  aria-label={"Compliance & Certifications"}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.link116
                  )}
                  title={"Compliance & Certifications"}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <PlasmicLink__
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__qdfO
                        )}
                        component={Link}
                        href={
                          hasVariant(globalVariants, "mobile", "mobileXSmall")
                            ? `/m/compliance-and-certifications`
                            : `/m/compliance-and-certifications`
                        }
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        <React.Fragment>
                          {"Compliance & Certifications"}
                        </React.Fragment>
                      </PlasmicLink__>
                    }
                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
                <div
                  data-plasmic-name={"link118"}
                  data-plasmic-override={overrides.link118}
                  aria-label={"Privacy Policy"}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.link118
                  )}
                  title={"Privacy Policy"}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <PlasmicLink__
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__u4Eb
                        )}
                        component={Link}
                        href={
                          hasVariant(globalVariants, "mobile", "mobileXSmall")
                            ? `/m/privacy-policy`
                            : `/m/privacy-policy`
                        }
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {"Privacy Policy"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
                <div
                  data-plasmic-name={"link117"}
                  data-plasmic-override={overrides.link117}
                  aria-label={"Accessibility Statement"}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.link117
                  )}
                  title={"Accessibility Statement"}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <PlasmicLink__
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__awqw
                        )}
                        component={Link}
                        href={
                          hasVariant(globalVariants, "mobile", "mobileXSmall")
                            ? `/m/accessibility-statement`
                            : `/m/accessibility-statement`
                        }
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {"Accessibility Statement"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  navs: [
    "navs",
    "desktop",
    "generalStayInTouch",
    "general",
    "head",
    "items",
    "link",
    "link2",
    "link3",
    "link5",
    "link6",
    "stayInTouch",
    "head2",
    "links",
    "x",
    "fb",
    "ig",
    "li",
    "th",
    "resources2",
    "resources",
    "head5",
    "items4",
    "link36",
    "link38",
    "link37",
    "mobile",
    "generaSolutions",
    "general3",
    "head11",
    "items9",
    "link81",
    "link82",
    "link83",
    "link85",
    "link86",
    "stayInTouch3",
    "head12",
    "links3",
    "x3",
    "fb3",
    "ig3",
    "li3",
    "th3",
    "productsResources",
    "resources5",
    "resources6",
    "head15",
    "items12",
    "link116",
    "link118",
    "link117"
  ],
  desktop: [
    "desktop",
    "generalStayInTouch",
    "general",
    "head",
    "items",
    "link",
    "link2",
    "link3",
    "link5",
    "link6",
    "stayInTouch",
    "head2",
    "links",
    "x",
    "fb",
    "ig",
    "li",
    "th",
    "resources2",
    "resources",
    "head5",
    "items4",
    "link36",
    "link38",
    "link37"
  ],
  generalStayInTouch: [
    "generalStayInTouch",
    "general",
    "head",
    "items",
    "link",
    "link2",
    "link3",
    "link5",
    "link6",
    "stayInTouch",
    "head2",
    "links",
    "x",
    "fb",
    "ig",
    "li",
    "th"
  ],
  general: [
    "general",
    "head",
    "items",
    "link",
    "link2",
    "link3",
    "link5",
    "link6"
  ],
  head: ["head"],
  items: ["items", "link", "link2", "link3", "link5", "link6"],
  link: ["link"],
  link2: ["link2"],
  link3: ["link3"],
  link5: ["link5"],
  link6: ["link6"],
  stayInTouch: ["stayInTouch", "head2", "links", "x", "fb", "ig", "li", "th"],
  head2: ["head2"],
  links: ["links", "x", "fb", "ig", "li", "th"],
  x: ["x"],
  fb: ["fb"],
  ig: ["ig"],
  li: ["li"],
  th: ["th"],
  resources2: [
    "resources2",
    "resources",
    "head5",
    "items4",
    "link36",
    "link38",
    "link37"
  ],
  resources: ["resources", "head5", "items4", "link36", "link38", "link37"],
  head5: ["head5"],
  items4: ["items4", "link36", "link38", "link37"],
  link36: ["link36"],
  link38: ["link38"],
  link37: ["link37"],
  mobile: [
    "mobile",
    "generaSolutions",
    "general3",
    "head11",
    "items9",
    "link81",
    "link82",
    "link83",
    "link85",
    "link86",
    "stayInTouch3",
    "head12",
    "links3",
    "x3",
    "fb3",
    "ig3",
    "li3",
    "th3",
    "productsResources",
    "resources5",
    "resources6",
    "head15",
    "items12",
    "link116",
    "link118",
    "link117"
  ],
  generaSolutions: [
    "generaSolutions",
    "general3",
    "head11",
    "items9",
    "link81",
    "link82",
    "link83",
    "link85",
    "link86",
    "stayInTouch3",
    "head12",
    "links3",
    "x3",
    "fb3",
    "ig3",
    "li3",
    "th3"
  ],
  general3: [
    "general3",
    "head11",
    "items9",
    "link81",
    "link82",
    "link83",
    "link85",
    "link86"
  ],
  head11: ["head11"],
  items9: ["items9", "link81", "link82", "link83", "link85", "link86"],
  link81: ["link81"],
  link82: ["link82"],
  link83: ["link83"],
  link85: ["link85"],
  link86: ["link86"],
  stayInTouch3: [
    "stayInTouch3",
    "head12",
    "links3",
    "x3",
    "fb3",
    "ig3",
    "li3",
    "th3"
  ],
  head12: ["head12"],
  links3: ["links3", "x3", "fb3", "ig3", "li3", "th3"],
  x3: ["x3"],
  fb3: ["fb3"],
  ig3: ["ig3"],
  li3: ["li3"],
  th3: ["th3"],
  productsResources: [
    "productsResources",
    "resources5",
    "resources6",
    "head15",
    "items12",
    "link116",
    "link118",
    "link117"
  ],
  resources5: [
    "resources5",
    "resources6",
    "head15",
    "items12",
    "link116",
    "link118",
    "link117"
  ],
  resources6: [
    "resources6",
    "head15",
    "items12",
    "link116",
    "link118",
    "link117"
  ],
  head15: ["head15"],
  items12: ["items12", "link116", "link118", "link117"],
  link116: ["link116"],
  link118: ["link118"],
  link117: ["link117"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  navs: "div";
  desktop: "div";
  generalStayInTouch: "div";
  general: "div";
  head: "h6";
  items: "nav";
  link: "div";
  link2: "div";
  link3: "div";
  link5: "div";
  link6: "div";
  stayInTouch: "div";
  head2: "h6";
  links: "div";
  x: "a";
  fb: "a";
  ig: "a";
  li: "a";
  th: "a";
  resources2: "div";
  resources: "div";
  head5: "h6";
  items4: "nav";
  link36: "div";
  link38: "div";
  link37: "div";
  mobile: "div";
  generaSolutions: "div";
  general3: "div";
  head11: "h6";
  items9: "nav";
  link81: "div";
  link82: "div";
  link83: "div";
  link85: "div";
  link86: "div";
  stayInTouch3: "div";
  head12: "h6";
  links3: "div";
  x3: "a";
  fb3: "a";
  ig3: "a";
  li3: "a";
  th3: "a";
  productsResources: "div";
  resources5: "div";
  resources6: "div";
  head15: "h6";
  items12: "nav";
  link116: "div";
  link118: "div";
  link117: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFooterTopNav__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFooterTopNav__VariantsArgs;
    args?: PlasmicFooterTopNav__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFooterTopNav__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFooterTopNav__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFooterTopNav__ArgProps,
          internalVariantPropNames: PlasmicFooterTopNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFooterTopNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "navs") {
    func.displayName = "PlasmicFooterTopNav";
  } else {
    func.displayName = `PlasmicFooterTopNav.${nodeName}`;
  }
  return func;
}

export const PlasmicFooterTopNav = Object.assign(
  // Top-level PlasmicFooterTopNav renders the root element
  makeNodeComponent("navs"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    generalStayInTouch: makeNodeComponent("generalStayInTouch"),
    general: makeNodeComponent("general"),
    head: makeNodeComponent("head"),
    items: makeNodeComponent("items"),
    link: makeNodeComponent("link"),
    link2: makeNodeComponent("link2"),
    link3: makeNodeComponent("link3"),
    link5: makeNodeComponent("link5"),
    link6: makeNodeComponent("link6"),
    stayInTouch: makeNodeComponent("stayInTouch"),
    head2: makeNodeComponent("head2"),
    links: makeNodeComponent("links"),
    x: makeNodeComponent("x"),
    fb: makeNodeComponent("fb"),
    ig: makeNodeComponent("ig"),
    li: makeNodeComponent("li"),
    th: makeNodeComponent("th"),
    resources2: makeNodeComponent("resources2"),
    resources: makeNodeComponent("resources"),
    head5: makeNodeComponent("head5"),
    items4: makeNodeComponent("items4"),
    link36: makeNodeComponent("link36"),
    link38: makeNodeComponent("link38"),
    link37: makeNodeComponent("link37"),
    mobile: makeNodeComponent("mobile"),
    generaSolutions: makeNodeComponent("generaSolutions"),
    general3: makeNodeComponent("general3"),
    head11: makeNodeComponent("head11"),
    items9: makeNodeComponent("items9"),
    link81: makeNodeComponent("link81"),
    link82: makeNodeComponent("link82"),
    link83: makeNodeComponent("link83"),
    link85: makeNodeComponent("link85"),
    link86: makeNodeComponent("link86"),
    stayInTouch3: makeNodeComponent("stayInTouch3"),
    head12: makeNodeComponent("head12"),
    links3: makeNodeComponent("links3"),
    x3: makeNodeComponent("x3"),
    fb3: makeNodeComponent("fb3"),
    ig3: makeNodeComponent("ig3"),
    li3: makeNodeComponent("li3"),
    th3: makeNodeComponent("th3"),
    productsResources: makeNodeComponent("productsResources"),
    resources5: makeNodeComponent("resources5"),
    resources6: makeNodeComponent("resources6"),
    head15: makeNodeComponent("head15"),
    items12: makeNodeComponent("items12"),
    link116: makeNodeComponent("link116"),
    link118: makeNodeComponent("link118"),
    link117: makeNodeComponent("link117"),

    // Metadata about props expected for PlasmicFooterTopNav
    internalVariantProps: PlasmicFooterTopNav__VariantProps,
    internalArgProps: PlasmicFooterTopNav__ArgProps
  }
);

export default PlasmicFooterTopNav;
/* prettier-ignore-end */
